/**
 * Visual identity for the two coverage sources on the ICR Coverage tab.
 * Color is paired with a label (and icon at the call site) so sources
 * stay distinguishable without relying on color alone.
 * Tracks and selected fills stay muted — never a vivid wash.
 */
export const COVERAGE_SOURCE = {
    DATA: {
        id: 'data',
        label: 'Data',
        color: '#3D5C57',
        track: '#F3F4F6',
        accent: '#5B7370',
    },
    ANALYTICS: {
        id: 'analytics',
        label: 'Analytics',
        color: '#4B4E8A',
        track: '#F3F4F6',
        accent: '#5C6094',
    },
};
